// Module
var code = "<div class=\"view-v5-frame\"> <iframe class=\"{{ $ctrl.frameClasses }}\" ng-src=\"{{ $ctrl.iframeSrc }}\"></iframe> </div> ";
// Exports
export default code;